import Link from "next/link";
import React from "react";

import StandardLink from "@afa-shared/afa-components/dist/StandardLink";

enum LinkType {
  External = "open_in_new",
  Internal = "arrow_forward",
  File = "file_download",
}

interface iTrackedLink {
  linkText: string;
  url: string;
  linkVariant?: "link" | "button";
  linkType?: LinkType;
  target?: string;
  onClick?: (value?: any) => void;
  hideIcon?: boolean;
  buttonStyle?: "primary" | "secondary";
  color?: string;
  ariaLabel?: string;
  prefetch?: boolean;
  dataTestId?: string;
  className?: string;
  dataContentfulEntryId?: string;
  dataContentfulFieldId?: string;
}

const TrackedLink = ({
  url,
  linkText,
  linkVariant = "link",
  linkType = LinkType.Internal,
  target = "_self",
  onClick,
  hideIcon,
  buttonStyle,
  color,
  ariaLabel,
  prefetch = false,
  dataTestId,
  className,
  dataContentfulEntryId,
  dataContentfulFieldId,
}: iTrackedLink): React.ReactNode => {
  const standardLink = (
    <StandardLink
      linkType={linkType}
      linkText={linkText}
      linkUrl={url}
      variant={linkVariant}
      target={target}
      buttonStyle={buttonStyle}
      color={color}
      className={className}
      hideIcon={hideIcon}
      onClick={onClick}
      linkMetaTitle={ariaLabel}
      dataTestId={dataTestId}
      data-contentful-entry-id={dataContentfulEntryId}
      data-contentful-field-id={dataContentfulFieldId}
    />
  );

  if (linkType === LinkType.External) {
    return standardLink;
  }

  // TODO: Get rid of legacyBehavior here. StandardLink renders an <a> tag so lecacyBehavior is currently needed.
  return (
    <Link href={url} prefetch={prefetch} legacyBehavior>
      {standardLink}
    </Link>
  );
};
export default TrackedLink;
